//import Vue from "vue";
//import { APP_MODE } from "@/modules/enums";

import mUtils from "@/modules/utils";

export default {
  state: {
    menuClassify: 0,
    menuDisabled: false,

    //rootCatID: 0,
    rootCatIDs: [],

    menu: [],
    items: [],
    redeemMenu: [],
    redeemItems: [],

    lastUpdated: undefined,
  },

  getters: {
    menu: (state, getters, rootState) => {
      let n_menu = [];
      if (state.menuClassify == 1) {
        n_menu = state.redeemMenu;
      } else if (state.menuClassify == 0) {
        n_menu = state.menu;
      }

      if (n_menu == null) n_menu = [];

      /*
      const rootCatID = state.rootCatID;
      if (rootCatID > 0) {
        n_menu = n_menu.filter(
          cat =>
            cat.ID < 0 ||
            cat.fullID == null ||
            cat.fullID.split("/").includes(rootCatID.toString())
        );
      }
      */
      const rootCatIDs = state.rootCatIDs;
      if (rootCatIDs.length > 0) {
        n_menu = n_menu.filter(
          cat => cat.ID < 0 || cat.fullID == null || rootCatIDs.some(i => cat.fullID.split("/").includes(i.toString()))
        );
      }

      if (getters.appName != "mrs.app.orderpad")
        n_menu = n_menu.filter(cat => cat.ID < 0 || cat.orderTypes.includes(rootState.Order.order.orderType));

      return n_menu;
    },

    menuItems: state => {
      return state.items;
    },

    menuHome: (state, getters) => {
      if (getters.categoryPosition == "center") return "MenuCategory";
      else return "MenuFull";
    },

    categoryDescr: (state, getters, rootState) => cat => {
      let descr = "";
      if (cat) {
        descr = cat.descr;

        if (rootState.languageSelected) {
          let lang = rootState.languageSelected;
          if (lang.descrIndex == 1 && cat.descr1 != "") descr = cat.descr1;
          else if (lang.descrIndex == 2 && cat.descr2 != "") descr = cat.descr2;
        }
      }
      return descr;
    },

    categoryPosition: (state, getters, rootState) => {
      let position = "top";

      if (rootState.Store.store && rootState.Store.store.config && rootState.Store.store.config.categoryPosition)
        position = rootState.Store.store.config.categoryPosition;

      return position;
    },

    itemDescr: (state, getters, rootState) => item => {
      let descr = "";
      if (item) {
        descr = item.descr;

        if (rootState.languageSelected) {
          let lang = rootState.languageSelected;
          if (lang.descrIndex == 1 && item.descr1 != "") descr = item.descr1;
          else if (lang.descrIndex == 2 && item.descr2 != "") descr = item.descr2;
        }
      }
      return descr;
    },

    itemDetail: (state, getters, rootState) => item => {
      let detail = "";
      if (item) {
        detail = item.detail;

        if (rootState.languageSelected) {
          let lang = rootState.languageSelected;
          if (lang.descrIndex == 1 && item.descr1 != "") detail = item.detail1;
          else if (lang.descrIndex == 2 && item.descr2 != "") detail = item.detail2;
        }
      }
      return detail;
    },

    itemPrice: (state, getters, rootState) => item => {
      if (item == null) return 0;
      let price = item.price;
      if (rootState.member) {
        if (item.priceForMember) price = item.priceForMember;
        if (getters.memberVip && item.priceForVip) price = item.priceForVip;
      }

      return price;
    },

    itemSub: (state, getters) => item => {
      if (item == null) return 0;
      let price = getters.itemPrice(item);
      return (item.scalable ? price * item.weight : price) + item.defOptValue;
    },

    itemDiscountedSub: (state, getters) => item => {
      if (item == null) return 0;

      let discountedSub = getters.itemSub(item);
      if (item.itemDiscountable && item.itemDiscountRate > 0) {
        let discValue = mUtils.roundNumber((discountedSub * item.itemDiscountRate) / 100, 2);
        discountedSub = discountedSub - discValue;
      //discountedSub = discountedSub * (1 - item.itemDiscountRate / 100);
      }

      return discountedSub;
    },

    itemSoldout: (state, getters) => item => {
      if (item == null) return false;
      if (item.countable && getters.itemStockEnabled) return item.ohQty - getters.orderItemQtyTotal(item) <= 0;
      else return item.soldout;
    },

    itemNotEnoughPoint: (state, getters, rootState) => item => {
      if (item == null) return false;
      if (state.menuClassify == 1) {
        if (rootState.member && rootState.Order.order) {
          return rootState.member.MemberPointBalance < rootState.Order.order.redeemedPointsTotal + item.redeemPoints;
        } else return true;
      } else return false;
    },

    itemAvailableQty: (state, getters, rootState) => item => {
      let ohQty = 0;
      if (item == null) return ohQty;

      if (item.redeemItem) {
        if (rootState.member && rootState.Order.order) {
          ohQty = Math.floor(
            (rootState.member.MemberPointBalance - rootState.Order.order.redeemedPointsTotal) / item.redeemPoints
          );
        }
      } else {
        if (item.countable) ohQty = item.ohQty;
        else ohQty = 99;
      }
      if (item.countable) ohQty -= getters.orderItemQtyTotal(item);
      if (ohQty < 0) ohQty = 0;
      return ohQty;
    },

    itemOptionGroupName: (state, getters, rootState) => og => {
      let name = "";
      if (og) {
        name = og.name;

        if (rootState.languageSelected) {
          let lang = rootState.languageSelected;
          if (lang.descrIndex == 1 && og.name1 != "") name = og.name1;
          else if (lang.descrIndex == 2 && og.name2 != "") name = og.name2;
        }
      }
      return name;
    },

    itemOptionDescr: (state, getters, rootState) => option => {
      let descr = "";
      if (option) {
        descr = option.descr;

        if (rootState.languageSelected) {
          let lang = rootState.languageSelected;
          if (lang.descrIndex == 1 && option.descr1 != "") descr = option.descr1;
          else if (lang.descrIndex == 2 && option.descr2 != "") descr = option.descr2;
        }
      }
      return descr;
    },

    itemOptionPrice: (state, getters, rootState) => opt => {
      if (opt == null) return 0;
      let price = opt.price;
      if (rootState.member) {
        if (opt.priceForMember) price = opt.priceForMember;
        if (getters.memberVip && opt.priceForVip) price = opt.priceForVip;
      }

      return price;
    },

    mainMenuEnabled: (state, getters, rootState) => {
      let enabled = false;
      if (rootState.Store.store && rootState.Store.store.config && rootState.Store.store.config.mainMenuEnabled)
        enabled = rootState.Store.store.config.mainMenuEnabled && getters.categoryPosition != "center";
      return enabled;
    },

    suggestedItems: (state, getters, rootState) => {
      let items;
      if (state.menu && state.menu.length > 0) {
        let favCat = state.menu.find(cat => cat.ID == -1);
        if (favCat)
          items = favCat.items.filter(
            item =>
              item.orderTypes.includes(rootState.Order.order.orderType) &&
              !item.bItem &&
              !item.disabled &&
              !item.orderDisabled &&
              !item.soldout
          );

        if (items && items.length > 0 && rootState.Order.order.orderItems.length > 0) {
          let orderedItemIDs = rootState.Order.order.orderItems.map(y => y.ID);
          items = items.filter(item => !orderedItemIDs.includes(item.ID));
        }
      }

      if (items == null) items = [];
      else if (items.length > 10) items = items.slice(0, 10);

      //console.log("suggestedItems", items);
      return items;
    },
  },

  mutations: {
    menuClassify(state, payload) {
      state.menuClassify = payload;
    },

    menuDisabled(state, payload) {
      state.menuDisabled = payload;
    },

    /*
    rootCatID(state, payload) {
      state.rootCatID = payload;
    },
    */

    rootCatIDs(state, payload) {
      if (payload && Array.isArray(payload)) state.rootCatIDs = payload;
    },

    menu(state, payload) {
      state.menu = payload;
      state.lastUpdated = new Date();
    },

    items(state, payload) {
      state.items = payload;
    },

    redeemMenu(state, payload) {
      state.redeemMenu = payload;
    },

    redeemItems(state, payload) {
      state.redeemItems = payload;
    },
  },
};
